
//
document.querySelectorAll('summary').forEach(element => element.addEventListener('click', (event) => {

    //
    const detailsElement = event.target.parentElement;
    const contentElement = event.target.nextElementSibling;

    //chrome sometimes has a hiccup and gets stuck.
    if (contentElement.classList.contains('animation')) {

        //so we make sure to remove those classes manually,
        contentElement.classList.remove('animation', 'collapsing');

        //enforce a reflow so that collapsing may be animated again,
        void element.offsetWidth;

        //and fallback to the default behaviour this time.
        return;

    }

    //
    const onAnimationEnd = (callback) => {
        return contentElement.addEventListener('animationend', callback, { once: true });
    };

    //request an animation frame to force Safari 16 to actually perform the animation
    requestAnimationFrame(() => contentElement.classList.add('animation'));

    //
    onAnimationEnd(() => contentElement.classList.remove('animation'));

    //
    if (detailsElement.getAttribute('open') !== null) {

        //prevent default collapsing and delay it until the animation has completed
        event.preventDefault();

        //
        contentElement.classList.add('collapsing');
        onAnimationEnd(() => {
            detailsElement.removeAttribute('open');
            contentElement.classList.remove('collapsing');
        });

    }

}));
